import { OptionsList } from "./OptionsList";

import { priceFormat } from "../../../utils/priceFormat";

export const OptionCard = ({
  data,
  price,
  timeline,
  selected = false,
  onClick,
}) => {
  const { popular, title, subtitle, image, options, description } = data;

  return (
    <div
      className={`app-ai-quote-card ${
        selected && "app-ai-quote-card-selected"
      } ${popular && "app-ai-quote-card-popular"}`}
    >
      <div className="app-ai-quote-card-header">
        {popular && (
          <span className="app-ai-quote-card-badge">Most Popular</span>
        )}
        <div className="app-ai-quote-card-headline">
          <div className="app-ai-quote-card-icon-holder">
            <img
              src={image.url}
              alt={image.alt}
              width={image.width}
              height={image.height}
            />
          </div>
          <div className="app-ai-quote-card-headline-text">
            <h4 className="app-ai-quote-card-title">{title}</h4>
            {subtitle && (
              <p className="app-ai-quote-card-subtitle">{subtitle}</p>
            )}
          </div>
        </div>
        <div className="app-ai-quote-card-price-container">
          <p className="app-ai-quote-card-price-block">
            <strong className="app-ai-quote-card-price-number">
              {priceFormat(price)}
            </strong>
          </p>
          {timeline && (
            <p className="app-ai-quote-card-timeline">
              / {timeline} business day{timeline > 1 ? "s" : ""}
            </p>
          )}
        </div>
        <button
          type="button"
          className={`app-ai-quote-card-button ${
            selected && "app-ai-quote-card-selected-button"
          }`}
          onClick={onClick}
        >
          {selected ? "Selected" : "Choose option"}
        </button>
        {description && (
          <p className="app-ai-quote-card-description">{description}</p>
        )}
      </div>
      <OptionsList data={options} />
    </div>
  );
};
